import Chain from './Chain';
import KeyValue from './KeyValue';
import SideBySide from './SideBySide';
import Stacked from './Stacked';

export default {
    Chain,
    KeyValue,
    SideBySide,
    Stacked,
};
